<cac-dialog-layout submitBtn="Ok" (onSubmit)="onSubmit()">
  <div>
    <image-cropper
      [imageFile]="data.file"
      [maintainAspectRatio]="true"
      [aspectRatio]="data.aspectRatio"
      (imageCropped)="imageCropped($event)"
      format="webp"
    ></image-cropper>
  </div>
</cac-dialog-layout>
